import { autoinject, transient } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { QueriesClientService } from "../../../../services/queries/queries-client.services";
import { SelectedLookupAuditDialog } from "./selected-lookup-audit-dialog";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";
import { PLATFORM, useView } from "aurelia-framework";

@autoinject
@transient()
@useView(PLATFORM.moduleName("views/pages/admin/manage-lookups/rightship-lookup-audit-dialog.html"))
export class RightshipSelectedLookupAuditDialog extends SelectedLookupAuditDialog {



    constructor(dialogClient: DialogClientService, queriesClientService: QueriesClientService,
        notificationClientService: NotificationClientService, i18N: I18N, configService: ConfigService) {
        super(dialogClient, queriesClientService, notificationClientService, i18N, configService);
     }

     public getUrl(){
        return  `/odata/RightShipAudits/Genesis.GetAuditsByAction(entityTypeId=${this.item.entityType},entityId=null,action='${this.actionFilter}')?$orderby=timestamp desc`;
    }
}